/* eslint-disable no-param-reassign */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createAction, createReducer } from '@reduxjs/toolkit';
import hondaRestApi from '../apis/hondaRestApi';
import { GET_BUILD_ERROR_CODE } from '../apiHooks/types';
export var userInteractedWithBap = createAction('savedBuild/userInteractedBap');
export var displayedSummaryAlerts = createAction('savedBuild/displaySummaryAlert');
export var initialState = {
    currentBuilds: {},
    visibleAlerts: { config: false, price: false },
    userInteractions: { config: false, warranty: false, paymentCalculator: false },
};
var savedBuild = createReducer(initialState, function (builder) {
    builder
        .addCase(displayedSummaryAlerts, function (state, action) {
        state.visibleAlerts = __assign(__assign({}, state.visibleAlerts), action.payload);
    })
        .addCase(userInteractedWithBap, function (state, action) {
        state.userInteractions = __assign(__assign({}, state.userInteractions), action.payload);
    })
        .addMatcher(hondaRestApi.endpoints.getSavedBuild.matchFulfilled, function (state, action) {
        var _a;
        var payload = action.payload, meta = action.meta;
        if (!(payload === null || payload === void 0 ? void 0 : payload.isSuccess) && (payload === null || payload === void 0 ? void 0 : payload.errorCode) === GET_BUILD_ERROR_CODE) {
            state.currentBuilds[meta.arg.originalArgs.buildId] = { isError: true, scopes: [] };
            return;
        }
        if (!((_a = payload === null || payload === void 0 ? void 0 : payload.model) === null || _a === void 0 ? void 0 : _a.isAvailableInBap)) {
            state.currentBuilds[meta.arg.originalArgs.buildId] = { isError: true, scopes: [] };
            return;
        }
        state.currentBuilds[meta.arg.originalArgs.buildId] = payload;
    });
});
export var selectVisibleAlerts = function (state) { return state.savedBuild.visibleAlerts; };
export var selectUserBapInteractions = function (state) { return state.savedBuild.userInteractions; };
export var selectBuildById = function (state, id) {
    return (id && state.savedBuild.currentBuilds[id]) || null;
};
export default savedBuild;
